import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { useSocket } from './SocketContext';
import { buildApiUrl } from '../config/api.config';

const FoodContext = createContext();

export const FoodProvider = ({ children }) => {
    const [foodList, setFoodList] = useState([]);
    const [loading, setLoading] = useState(true);
    const socket = useSocket();

    // Determine activeRestaurantId once in the component scope
    const user = JSON.parse(localStorage.getItem("userDetails"));
    const selectedRestId = localStorage.getItem("currentRestaurantId");
    let activeRestaurantId = (user?.role === 'owner' || user?.role === 'user') ? selectedRestId : user?.restaurantId;

    // Handle populated restaurantId object
    if (activeRestaurantId && typeof activeRestaurantId === 'object') {
        activeRestaurantId = activeRestaurantId._id;
    }

    const fetchFoodList = async () => {
        try {
            if (!activeRestaurantId) {
                setFoodList([]);
                setLoading(false);
                return;
            }

            const response = await axios.get(buildApiUrl(`food/list?restaurantId=${activeRestaurantId}`));
            setFoodList(response.data.data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching food list:', error);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchFoodList();

        if (socket) {
            socket.emit('joinFoodRoom');
            
            socket.on('foodAdded', (newFood) => {
                setFoodList(prev => [...prev, newFood]);
            });

            socket.on('foodRemoved', (foodId) => {
                setFoodList(prev => prev.filter(food => food._id !== foodId));
            });

            return () => {
                socket.off('foodAdded');
                socket.off('foodRemoved');
            };
        }
    }, [socket]);

    return (
        <FoodContext.Provider value={{ foodList, loading, fetchFoodList }}>
            {children}
        </FoodContext.Provider>
    );
};

export const useFood = () => {
    return useContext(FoodContext);
};